import axios from "@axios";
import * as ep from "./endpoints";
import { BACK_BASE_URL } from "@/base-url";
export default class Service {
  static async verifyCode(payload) {
    return await axios
      .post(ep.VERIFY(payload.id), { code: payload.code })
      .then((res) => res);
  }
  static proceedToNextStep(payload) {
    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify(payload.form);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    return fetch(`${BACK_BASE_URL}/${payload.ep}`, requestOptions)
      .then((response) => response.text())
      .then((result) => JSON.parse(result));

    //  axios.post(ep.FIRST_STEP, payload).then((res) => res.data);
  }
  static saveSecondStep(payload) {
    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify(payload);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    return fetch(`${BACK_BASE_URL}/${ep.SECOND_STEP}`, requestOptions)
      .then((response) => response.text())
      .then((result) => JSON.parse(result));
  }
  static saveThirdStep(payload) {
    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify(payload);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    return fetch(`${BACK_BASE_URL}/${ep.THIRD_STEP}`, requestOptions).then(
      (response) => response.text()
    );
  }
}
